import { createStorage } from './createStorage';

export const useLocalStorage = createStorage('local');
